import React from 'react'
import { FormattedMessage, defineMessages } from 'react-intl'
import { Box, Button, Container, Flex, H2, Text } from '../../../components'

const messages = defineMessages({
  title: {
    id: 'modules.Registration.IntroStep.title',
    defaultMessage: 'Bike sharing for companies',
  },
  descriptionService: {
    id: 'modules.Registration.IntroStep.descriptionService',
    defaultMessage:
      'Register your company, add a payment card, and give access to others who will be able to create and share voucher codes.',
  },
  descriptionPayment: {
    id: 'modules.Registration.IntroStep.descriptionPayment',
    defaultMessage:
      "We will only charge you for vouchers used. Any vouchers that aren't redeemed at the end of each month will not show up on your bill.",
  },
  descriptionTerms: {
    id: 'modules.Registration.IntroStep.descriptionTerms',
    defaultMessage:
      'By clicking «Start riding», you agree to receive a receipt for each charge.',
  },
  getStarted: {
    id: 'modules.Registration.IntroStep.getStarted',
    defaultMessage: 'Start riding',
  },
})

const IntroStep = () => {
  return (
    <Container variant="narrow" mt="sm">
      <Flex
        flex={1}
        flexWrap="wrap"
        mb="sm"
        textAlign="center"
        justifyContent="center"
        justifyItems="center"
        alignItems="center"
        column
      >
        <H2 typoStyle="md" mb="sm" mt={{ xs: 4, lg: 0 }}>
          <FormattedMessage {...messages.title} />
        </H2>

        <Box mb="sm">
          <Text mb="xxs">
            <FormattedMessage {...messages.descriptionService} />
          </Text>

          <Text mb="xxs">
            <FormattedMessage {...messages.descriptionPayment} />
          </Text>

          <Text>
            <FormattedMessage {...messages.descriptionTerms} />
          </Text>
        </Box>

        <Box>
          <Button variant="primary" shape="cool" type="submit">
            <FormattedMessage {...messages.getStarted} />
          </Button>
        </Box>
      </Flex>
    </Container>
  )
}

export default IntroStep
